import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SITE } from "@/lib/site";

const HERO_IMG =
  "https://images.pexels.com/photos/6451234/pexels-photo-6451234.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1800";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative grain overflow-hidden bg-[#0A1128] text-white"
    >
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Alaska midnight sun over mountains"
          className="w-full h-full object-cover opacity-40"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A1128] via-[#0A1128]/85 to-[#0A1128]/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A1128] via-transparent to-transparent" />
      </div>

      <div className="relative mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 pt-24 md:pt-36 pb-24 md:pb-40">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-10 lg:col-span-9">
            <div className="flex items-center gap-3 reveal">
              <span className="brand-rule" />
              <span className="overline !text-amber-500">Preventive Presence</span>
            </div>

            <h1
              data-testid="hero-headline"
              className="reveal reveal-delay-1 font-display font-black mt-6 text-[44px] sm:text-6xl md:text-7xl lg:text-[88px] leading-[0.98] tracking-tighter"
            >
              We don't chase crisis,
              <br />
              <span className="text-amber-500">We stand watch</span> over it.
            </h1>

            <p
              data-testid="hero-subhead"
              className="reveal reveal-delay-2 mt-8 max-w-2xl text-base md:text-lg text-slate-300 leading-relaxed"
            >
              The Midnight Sun Working Dog Coalition deploys disciplined canine-handler
              teams to proactively stabilize human environments — a structured,
              non-clinical framework for schools, veteran communities, rural facilities,
              and behavioral health systems.
            </p>

            <div className="reveal reveal-delay-3 mt-10 flex flex-col sm:flex-row gap-3">
              <Link
                to="/contact"
                data-testid="hero-cta-partner"
                className="group inline-flex items-center justify-center gap-3 bg-white text-slate-900 hover:bg-amber-500 hover:text-white px-7 py-4 font-semibold text-sm transition-colors"
              >
                Partner with us
                <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
              </Link>
              <Link
                to="/donate"
                data-testid="hero-cta-support"
                className="inline-flex items-center justify-center gap-3 border border-white/30 hover:border-amber-500 hover:text-amber-500 px-7 py-4 font-semibold text-sm transition-colors"
              >
                Support our mission
              </Link>
            </div>

            <div className="reveal reveal-delay-4 mt-16 grid grid-cols-1 sm:grid-cols-2 md:max-w-md gap-x-4 gap-y-8 border-t border-white/10 pt-10">
              {[
                { k: "Based in", v: "Anchorage, AK" },
              ].map((s) => (
                <div key={s.k}>
                  <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500">
                    {s.k}
                  </div>
                  <div className="mt-2 font-display font-bold text-xl md:text-2xl text-white">
                    {s.v}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
